// removed by extract-text-webpack-plugin
module.exports = {"page__header":"src-components-PageHeader----PageHeader-module---page__header---3P0hM","page__header__content":"src-components-PageHeader----PageHeader-module---page__header__content---WZKlE","page__header__title":"src-components-PageHeader----PageHeader-module---page__header__title---2d6ID","statistic":"src-components-PageHeader----PageHeader-module---statistic---2lKSF","page__header__image":"src-components-PageHeader----PageHeader-module---page__header__image---3B06L"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHeader/PageHeader.module.scss
// module id = 864
// module chunks = 168707334958949